const defaultState = {
    orderFlowConfig: {},
    config: {},
    key: undefined,
    title: null,
};

const state = defaultState;

const mutations = {
    resetState: state => Object.assign(state, defaultState),
    setKey: (state, key) => state.key = key,
    setOrderFlowConfig: (state, config) => state.orderFlowConfig = config,
    setFlowConfig: (state, config) => state.config = config,
    setTitle: (state, title) => state.title = title,
};

const actions = {
    resetState: ({ commit }) => commit('resetState'),
    setOrderFlowConfig: ({ commit }, config) => commit('setOrderFlowConfig', config),
    setFlowConfig: ({ commit }, config) => commit('setFlowConfig', config),
    setKey: ({ commit }, key) => commit('setKey', key),
    setTitle: ({ commit }, title) => commit('setTitle', title),
};

const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
